import { Account } from 'app/shared/account/account.model';

export interface InactiveAccountView {
  siteId: number;
  name: string;
}

/** Shown only when the current account is expired or paused and this superadmin unlocked it. */
export function resolveInactiveAccountView(
  account: Account | undefined,
  unlockedSiteIds: readonly number[],
): InactiveAccountView | undefined {
  if (!(account?.isExpired || account?.isPaused) || account.siteId === undefined) {
    return undefined;
  }
  if (!unlockedSiteIds.includes(account.siteId)) {
    return undefined;
  }
  return { siteId: account.siteId, name: account.name ?? '' };
}
